import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagSO(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUiO3lCU4lud6FaZ5fb3+Mfb8pi/7Haq5gZzvxcAAAF+SURBVDjL7VDBTkIxENzGg9fWGrwSinf6NnDXFLwqPOOZyAdIwv/HmfZReE/wbuKEtruzM7OATH7HWP6MIFwbN2EsAWguI4RJA8GEVVad7hCOvpmoatBGOUCpC61oMNCZQKUQk6FregrAOJSEjFCe3ed5BBO0j3bTa8NQ0KTnPjEULNLqgiCqx8GlOk9Ldj4PUXkIvPesokZgmlLAo55NSeDru6NxlxJ/ho85B7CC2kXvvH98B1JKS77R5wznkACZY+3bVLF2tDHGimPlkOBGdb4CCQLgClfGzrvDUbCPJHMuEs7QLdlQHQt1EjBx1C2ohBsklIi3c6YvsDnh6brgIQteBgJjbHfM8TuYCmvFOswgxbH3KW3xZxtHMvuRQK+1Rvg5pA9326a9pVlygogF8gZ8dstozDxt4UBi2SF1Ga72C60cXm1hCJESTkru1pn1aza0YsQdeNiLveENC1+aOMoJmTVSoqyR4hcyUpCVtesoc+Sl3sVozQ/tP0S+ATzdlwX4VebIAAAAAElFTkSuQmCC",
    alt: "SO"
  }, props));
}